import moment from 'moment-timezone'
import Vue2Filters from 'vue2-filters'

const number = v => (v || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
const decimal = v => (v || 0).toFixed(2);

const date = (value, opt = 'YYYY.MM.DD') => (value && moment(value).format(opt) || '-');
const datetime = (value, opt = 'YYYY.MM.DD HH:mm:ss') => (value && moment(value).format(opt) || '-');
const utcdatetime = (value, opt = 'YYYY.MM.DD HH:mm:ss') => (value && moment(value).utc().format(opt) || '-');
const wfdatetime = (value, opt = 'YYYY.MM.DD HH:mm:ss') => (value && moment(value.replace(/[T|Z]/, ' ')).format(opt) || '-');
const sdatetime = (value) => value && moment(value).format(moment().startOf('d').isSame(moment(value).startOf('d')) ? 'HH:mm' : 'YYYY.MM.DD HH:mm') || '-';
const sdate = (value) => value && moment(value).format(moment().startOf('d').isSame(moment(value).startOf('d')) ? 'HH:mm' : 'YYYY.MM.DD') || '-';
const utcsdate = (value) => value && moment(value).utc().format(moment().startOf('d').isSame(moment(value).startOf('d')) ? 'HH:mm' : 'YYYY.MM.DD') || '-';
const dollar = (v) => { return v ? (new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD'})).format(v) : '-' }

var Filter = {
  install: function(Vue) {
    Vue.use(Vue2Filters);
    Vue.filter('decimal', decimal);
    Vue.filter('number', number);
    Vue.filter('dollar', dollar)
    Vue.filter('date', date);
    Vue.filter('datetime', datetime);
    Vue.filter('sdatetime', sdatetime);
    Vue.filter('sdate', sdate);
    Vue.filter('utcdatetime', utcdatetime);
    Vue.filter('utcsdate', utcsdate);
    Vue.filter('wfdatetime', wfdatetime);
  }
}

export default Filter;
export { number }

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Filter);
}
